import { combineReducers } from '@reduxjs/toolkit';
import formalQuoteReducer from 'formal_quote/slice';

const rootReducer = combineReducers({
  formalQuote: formalQuoteReducer,
});

export default rootReducer;
